(() => {
  function bindHeader(root = document) {
    root.querySelectorAll('[data-gg-mobile-menu]').forEach(menu => {
      if (menu.dataset.ggBound) return;
      menu.dataset.ggBound = 'true';
      const close = focus => {
        if (!menu.open) return;
        menu.open = false;
        if (focus) menu.querySelector('summary').focus();
      };
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(true); }
      });
      menu.addEventListener('click', event => { if (event.target.closest('a')) close(false); });
      document.addEventListener('pointerdown', event => {
        if (!menu.contains(event.target)) close(false);
      });
      window.matchMedia('(min-width: 1100px)').addEventListener('change', event => {
        if (event.matches) close(false);
      });
    });
  }
  bindHeader();
  document.addEventListener('shopify:section:load', event => bindHeader(event.target));
})();
